import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import users from './modules/users';
import orders from './modules/orders';
import checklist from './modules/checklist';
import customers from './modules/customers';
import dateRange from './modules/dateRange';
import stores from './modules/stores';
import supplier from './modules/supplier';
import distributor from './modules/distributor';
import userRoles from './modules/userRoles';
import notification from './modules/notification';
import componentState from './modules/componentState';
import pageComponents from './modules/pageComponents';
import presentation from './modules/presentation';
import theme from './modules/theme';
import { BAD_CREATE, BAD_LOAD, BAD_UPDATE, SUCCESS_CREATED, SUCCESS_UPDATED } from './modules/constants';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    auth,
    users,
    orders,
    supplier,
    customers,
    checklist,
    dateRange,
    stores,
    distributor,
    userRoles,
    notification,
    componentState,
    presentation,
    pageComponents,
    theme
  },
  mutations: {
    [BAD_CREATE](state, text) {
      Vue.notify({
        group: 'app',
        type: 'error',
        title: 'Error',
        text,
        duration: 60000
      });
    },
    [BAD_UPDATE](state, text) {
      Vue.notify({
        group: 'app',
        type: 'error',
        title: 'Error',
        text,
        duration: 60000
      });
    },
    [BAD_LOAD](state, text) {
      Vue.notify({
        group: 'app',
        type: 'error',
        title: 'Error',
        text,
        duration: 60000
      });
    },
    [SUCCESS_UPDATED](state, text) {
      if (!text) text = 'Saved success';
      Vue.notify({
        group: 'app',
        type: 'success',
        title: 'Update',
        text,
        duration: 60000
      });
    },
    [SUCCESS_CREATED](state, text) {
      if (!text) text = 'Saved success';
      Vue.notify({
        group: 'app',
        type: 'success',
        title: 'Create',
        text,
        duration: 3000
      });
    }
  },
  strict: debug
});
